import React, { useMemo } from 'react'
import { CalculatorInput } from '../types/CalculatorInput'

const Input = ( { calculatorInput: input }:Props ) => {

  const step: string = useMemo( () => {
    let step: string = '1'
    if( !input.decimals || input.decimals < 1 ) return step
    Array.from({ length: input.decimals - 1 }).forEach( () => {
      step = '0' + step
    })
    return "0." + step
  }, [ input ] )

  return ( 
    <div className="grid gap-x-4 md:gap-x-8 grid-cols-2 mt-5 md:mt-0">
      <div className="col-span-2 md:col-span-1 flex items-center font-normal text-base" >
        { input.name }
      </div>
      <div className="col-span-2 border rounded-lg h-10 my-px md:col-span-1 flex items-center relative" >
        {
          input.prefix && 
            <span className="w-1/4 h-full flex items-center justify-center bg-gray-100 rounded-lg">
              {input.prefix}
            </span>
        }
        <input 
          type="number" 
          step={ step }
          name={ input.id }
          placeholder={ input.placeholder?.toString() }
          className="h-full focus:outline-none w-full px-2 text-right rounded-lg" 
        />
        {
          input.sufix && 
            <span className="w-1/2 h-full flex items-center justify-center bg-gray-100 rounded-lg">
              {input.sufix}
            </span>
        }
      </div>
    </div>
  )
}

interface Props {
  calculatorInput: CalculatorInput
}


export { Input }
